import Vue from 'vue'


const transformer = ({ name, price, iva: tax, tax_withheld: taxWithHeld, total}) => {
  return {
    name,
    supplyName: name,
    price,
    unitPriceMXN: price,
    quantity: 1,
    realQuantity: 1,
    tax,
    taxWithHeld,
    total
  }
}

export default (affectedId, opts = {}) => {

  const url = `purchase/quantification_ghost_concept/${affectedId}/`
  return Vue.$http.get(url).then(response =>
    transformer(response.data)
    )
}



// WEBPACK FOOTER //
// ./src/services/purchase/fetchServiceConcept.js